<template>
  <div>
    <div class="pay-type">
      <span
        class="pay-type-btn"
        :class="customerPaymentMethod === '1' ? 'active' : ''"
        @click="changeType('1')"
        >在线支付</span
      >
      <span
        class="pay-type-btn"
        @click="changeType('2')"
        :class="customerPaymentMethod === '2' ? 'active' : ''"
        >公司转账</span
      >
    </div>
    <div class="content" v-if="customerPaymentMethod === '1'">
      <span>支持</span>
      <span>
        <img src="~@/assets/img/zfb.png" />
        支付宝、
      </span>
      <span>
        <img src="~@/assets/img/wx.png" />
        微信
      </span>
    </div>
    <div class="content" v-if="customerPaymentMethod === '2'">
      款到发货：下单后企业转账至工自仪对公账户，到账后发货。
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customerPaymentMethod: {
      type: String,
      default: '1'
    }
  },
  methods: {
    changeType (type) {
      this.$emit('changeType', type)
    }
  }
}
</script>

<style lang="scss" scoped>
.pay-type {
  .pay-type-btn {
    display: inline-block;
    margin-left: 16px;
    width: 100px;
    line-height: 28px;
    font-size: 14px;
    background: #fff;
    border: 1px solid #e4e7ed;
    text-align: center;
    cursor: pointer;
    color: #333;
    &:first-child {
      margin-left: 0;
    }
    &:hover,
    &.active {
      border-color: #3d88d4;
    }
  }
}
.content {
  display: flex;
  align-items: center;
  padding-top: 12px;
  color: #666;
  span {
    display: flex;
    align-items: center;
    line-height: 21px;
  }
  img {
    width: 18px;
    margin: 0 2px 0 4px;
  }
}
</style>
